export default __webpack_public_path__ + "static/media/spider.248744fa.ogg";